// extracted by mini-css-extract-plugin
export default {"subscriptionHeading":"SubscriptionHeading_solo_subscriptionHeading__L-0IZ"};